<template>
    <div class="card hotel-result mb-4">
      <div class="card-content">
        <div class="columns is-mobile is-multiline">
          <!-- Image skeleton -->
          <div class="column is-6">
            <b-skeleton
              height="200px"
              :animated="true"
            ></b-skeleton>
          </div>
  
          <!-- Content skeletons -->
          <div class="column is-6">
            <b-skeleton
              width="25%"
              :animated="true"
            ></b-skeleton>
            
            <b-skeleton
              width="75%"
              :animated="true"
              class="mt-5"
            ></b-skeleton>         
            
            <b-skeleton
              width="100%"
              :animated="true"
              class="mt-5"
            ></b-skeleton>
            
            <b-skeleton
              width="75%"
              :animated="true"
              class="mt-5"
            ></b-skeleton>       
            
            <b-skeleton
              width="100%"
              :animated="true"
              class="mt-5"
            ></b-skeleton>
            
            <b-skeleton
              width="75%"
              :animated="true"
              class="mt-5"
            ></b-skeleton>

            <b-skeleton
              width="25%"
              :animated="true"
            ></b-skeleton>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
  }
  </script>
  
  <style scoped>
  .mt-5 {
    margin-top: 1.25rem;
  }
  
  /* Optional: Add these if you want to match the original card styling more closely */
  .card {
    border-radius: 0.375rem;
    background-color: white;
  }

  .hotel-result {
    cursor: pointer;
    transition: box-shadow 0.3s ease;
    border: 1px solid #e7e8e9;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  
  .card-content {
    padding: 0.5rem;
  }
  </style>